import { useCallback, useState } from "react";
import ListItem from "./ListItem";
import DetailModal from "./DetailModal";

export default function List({ candidates, q }) {
  const [currentCandidate, setCurrentCandidate] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const openDetailModal = useCallback((candidate) => {
    setCurrentCandidate(candidate);
    setIsDetailModalOpen(true);
  })

  const closeDetailModal = useCallback(() => {
    setCurrentCandidate(null);
    setIsDetailModalOpen(false);
  });

  if (candidates.lenght === 0) {
    return (
      <div className="col-span-full text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900">
          {q ? "没有找到匹配的简历" : "暂无简历"}
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          {q ? "尝试使用其他关键词搜索" : "开始上传简历以建立您的简历库。"}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {candidates.map((it) => (
          <ListItem key={it.id} candidate={it} onOpen={openDetailModal} />
        ))}
      </div>
      <DetailModal candidate={currentCandidate} isOpen={isDetailModalOpen} onClose={closeDetailModal} />
    </>
  );
}
